import axios from 'axios';

// export const baseUrl = "http://192.168.1.13:8000/api/";
// export const mediaUrl = "http://192.168.1.13:8000/storage/uploads/";
export const baseUrl = "https://api.mysupportoo.com/api/";
export const mediaUrl = "https://api.mysupportoo.com/storage/uploads/";
export const apiGet = async (endpoint: string) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseUrl}${endpoint}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const apiPost = async (endpoint: string, body: any = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${baseUrl}${endpoint}`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

//dynamic image
const images = require.context(`/public/assets/images`, true);

export const dynamicImage = (image: string | undefined) => {
    return images(`./${image}`);
};

//dynamic Number
export function dynamicNumber(totalLength: number) {
    return Array.from({ length: totalLength }, (_, index) => index + 1);
};

/**
 * Reusable file upload utility.
 * Uploads a File object to the backend fileupload endpoint via multipart form-data.
 * Returns the stored filename string (e.g. "uuid.png") on success.
 */
export const uploadFile = async (file: File): Promise<string> => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Unauthorized: Token not found');

    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post(`${baseUrl}fileupload`, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    });

    return response.data.filename as string;
};

